import React from 'react';
import { Button, Upload, Icon, message } from "antd";
import firebase from "firebase";

import { deleteVideoFromFirebase } from "../../../../../services/firebase/storage";

const videoPlaceholder = "https://firebasestorage.googleapis.com/v0/b/implant-compare.appspot.com/o/images%2FvideoImage.png?alt=media&token=9e577473-5181-4221-b31a-92c8a4849869";

const UploadVideo = ps => {
  const { userClaims, ownChannel, state, setStateHandler, updateValue, item } = ps;
  const { uploading, fileList, progressUpload, values, controls } = state;
  const { uploadVideo } = values;

  const handleUploadVideo = async(uniqueId, channel) => {
    const formData = new FormData();

    if (!channel) {
      message.warning('Please select channel or get permission for channel!')
      return null
    }

    fileList.forEach((file) => {
      formData.set('files[]', file);
    });

    setStateHandler({ uploading: true });

    // this.cancelButtonHandler();
    const reader = new FileReader();
    const file = fileList[0];
    const oldFileName = (item && item.uploadVideo && item.uploadVideo.fileName) || '';

    const type = file.name.split('.');

    const isUsageFormat = type[1] === 'webm' || type[1] === 'mp4' || type[1] === 'ogg';

    if (isUsageFormat) {
      reader.onloadend = function () {
        const fileName = `${file.name}-${uniqueId}`;
        const data = new Blob([file], { type: `video/${type[1]}` });
        const storageRef = firebase.storage().ref();
        const uploadTask = storageRef.child(`videos/${fileName}`).put(data);

        uploadTask.on('state_changed',
          function(snapshot){
            let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
            setStateHandler({ progressUpload: progress });
            switch (snapshot.state) {
              case firebase.storage.TaskState.PAUSED:
                break;
              case firebase.storage.TaskState.RUNNING:
                break;
              default:
                break;
            }
          },
          function(error) {
            console.error('error', error);
            switch (error.code) {
              case 'storage/unauthorized':
                message.error('User doesn\'t have permission to access the object');
                break;

              default:
                message.error('Unknown error occurred, inspect error.serverResponse');
                break;
            }
          },
          function() {
            uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
              console.log('File available at', downloadURL);

              updateUploadFile(downloadURL, uniqueId, fileName, oldFileName)
            });
          }
        );
      };
    } else {
      message.error('Please, upload video with one of this format: webm, mp4, ogg');
      setStateHandler({uploading: false, fileList: []});
    }

    reader.onerror = function (e) {
      console.log("Failed file read: " + e.toString());
    };

    reader.readAsArrayBuffer(file);
  };

  const updateUploadFile = (downloadURL, uniqueId, fileName, oldFileName) => {
    message.success('Video uploaded');
    let uploadVideo = {
      uploadVideoUrl: downloadURL,
      uploadVideoId: uniqueId,
      fileName: fileName,
    };

    (oldFileName && oldFileName.length > 0) && deleteVideoFromFirebase(oldFileName);
    updateValue('uploadVideo', uploadVideo);
    setStateHandler({ uploading: false, uploadVideo: uploadVideo, fileList: [], progressUpload: 0 });
  }

  const uniqueId = new Date().getTime();
  let uploadValue = [];
  let isDisabled = true;

  if (fileList[0] && fileList[0].name) {
    uploadValue = [{
      uid: -1,
      name: fileList[0].name,
      status: 'uploading',
      url: '',
      thumbUrl: videoPlaceholder,
    }];

    isDisabled = false
  } else if (uploadVideo && uploadVideo.uploadVideoId) {
    uploadValue = [{
      uid: uploadVideo.uploadVideoId,
      name: uploadVideo.fileName,
      status: 'done',
      url: uploadVideo.uploadVideoUrl,
      thumbUrl: videoPlaceholder,
    }];

    isDisabled = true
  } else {
    uploadValue = [];
    isDisabled = true
  }

  const props = {
    listType: 'picture',
    fileList: uploadValue,
    beforeUpload: (file) => {
      setStateHandler({ fileList: [file] });
      return false;
    },
    onRemove: () => {
      updateValue('uploadVideo', {});
      setStateHandler({ uploadVideo: {}, fileList: [] });
    },
  };

  let channel = null;
  if (userClaims && userClaims.userType === 'Admin') {
    channel = controls.channel && controls.channel.value && controls.channel.value.id;
  } else if (userClaims && userClaims.userType === 'Contributor') {
      if (ownChannel && ownChannel.length > 0 ) channel = ownChannel
  }

  return (
    <div className="file-uploader-wr">
      {
        (uploadVideo && uploadVideo.uploadVideoUrl)&& (
          <video controls>
            <source src={uploadVideo.uploadVideoUrl} type="video/mp4" />
            <source src={uploadVideo.uploadVideoUrl} type="video/ogg" />
            <source src={uploadVideo.uploadVideoUrl} type="video/webm" />
          </video>
        )
      }
      <Upload {...props}>
        <Button>
          <Icon type="upload" /> Select File
        </Button>
      </Upload>
      <div>Usage format: webm, mp4, ogg</div>
      {
        !isDisabled && (
          <div className="progress-line-wr">
            <div
              className="progress-line"
              style={{ width: `${(progressUpload && progressUpload.toFixed(2)) || 0}%` }}
            >

            </div>
            <span>{`${(progressUpload && progressUpload.toFixed(2)) || 0}%`}</span>
          </div>
        )
      }
      <Button
        type="primary"
        onClick={() => handleUploadVideo(uniqueId, channel)}
        disabled={isDisabled}
        loading={uploading}
        style={{ marginTop: 16 }}
      >
        {uploading ? 'Uploading' : 'Start Upload' }
      </Button>
    </div>
  )
};

export default UploadVideo;


// WEBPACK FOOTER //
// ./src/pages/EventEditor/Content/EventForm/UploadVideo/index.js